/* eslint-disable */
import React, { useEffect, useState } from "react";
import Statistics from "..";
import { getCommunitiesStats, getStatisticsSuccess, getCommunitiesList } from "../../../actions";
import "./styles.scss";
import { connect } from "react-redux";
import Popup from "reactjs-popup";
import PeriodSelector from "../../PeriodSelector";
import infoIcon from "../../../assets/icons/info-gray-new.svg";
import { history } from "../../../config/stores";

const communitiesShortcuts = [
  {
    key: "byMembersRanges",              // Changed from "communitiesByMembersCount"
    label: "PARTICIPANTS",
  },
  {
    key: "byNoticesRanges",              // Changed from "communitiesByNoticesCount"
    label: "BOARD MESSAGES",
  },
  {
    key: "byCalendarEventsRanges",       // Changed from "communitiesByCalendarEventsCount"
    label: "CALENDAR",
  },
  {
    key: "byPollsRanges",                // Changed from "communitiesByPollsCount"
    label: "VOTING POLLS",
  },
  {
    key: "byMeetingsRanges",             // Changed from "communitiesByMeetingsCount"
    label: "MEETINGS",
  },
  {
    key: "byFilesRanges",                // Changed from "communitiesByFilesCount"
    label: "FILES",
  },
  // {
  //   key: "byFundCampaignsRanges",     // This is available in your API if you want to add it
  //   label: "FUND CAMPAIGNS",
  // },
  // {
  //   key: "byAssistantRequestsRanges", // This is available in your API if you want to add it
  //   label: "ASSISTANT REQUESTS",
  // },
];

const Communities = ({ getCommunitiesStats, getCommunitiesList, communities, communitiesList }) => {
  const [selected, setSelected] = useState("country");
  const [selPeriod, setSelPeriod] = useState({
    startDate: null,
    endDate: null,
  });
  const [hasUserChangedPeriod, setHasUserChangedPeriod] = useState(false);
  const [selectedPeriodLabel, setSelectedPeriodLabel] = useState("All time");
  const [selectedPeriodType, setSelectedPeriodType] = useState("all");

  useEffect(() => {
    getStatisticsSuccess({ type: "communities", loading: true });
    getCommunitiesStats({
      startDate: "",
      endDate: ""
    });
  }, []);

  useEffect(() => {
    // Only trigger API call when user has actually changed the period
    if (hasUserChangedPeriod) {
      const apiPayload = {
        startDate: selPeriod.startDate || "",
        endDate: selPeriod.endDate || "",
      };
      
      getCommunitiesStats(apiPayload);
    }
  }, [selPeriod, hasUserChangedPeriod]);

  const handlePeriodApply = (periodData) => {
    setSelPeriod({
      startDate: periodData.startDate,
      endDate: periodData.endDate,
    });
    setSelectedPeriodLabel(periodData.label);
    setSelectedPeriodType(periodData.type);
    setHasUserChangedPeriod(true);
  };

  const handleCommunitiesListClick = () => {
    // Navigate to the communities list page with period parameters
    const queryParams = new URLSearchParams();
    
    if (selPeriod.startDate) {
      queryParams.set('startDate', selPeriod.startDate);
    }
    if (selPeriod.endDate) {
      queryParams.set('endDate', selPeriod.endDate);
    }
    if (selectedPeriodLabel !== "All time") {
      queryParams.set('periodLabel', selectedPeriodLabel);
    }
    if (selectedPeriodType !== "all") {
      queryParams.set('periodType', selectedPeriodType);
    }
    
    const queryString = queryParams.toString();
    const url = queryString ? `/dashboard/communities/list?${queryString}` : '/dashboard/communities/list';
    
    history.push(url);
  };

  return (
    <div
      className="statistics-sessions-container col"
      style={{ overflow: "auto" }}
    >
      {/* Row 1: NEIGHBOURHOOD COMMUNITIES title and period selector */}
      <div className="communities-header">
        <h1 className="communities-title">
          <b>NEIGHBOURHOOD COMMUNITIES</b>
        </h1>
        <div className="period-selector">
          <p className="period-label">
            {selectedPeriodLabel}
          </p>
          <Popup
            className="popup-header-options-container"
            trigger={<div className="settings-icon" />}
            position="bottom right"
            closeOnDocumentClick
          >
            {(close) => (
              <PeriodSelector
                selectedPeriod={selectedPeriodType}
                onApply={(periodData) => {
                  handlePeriodApply(periodData);
                  close();
                }}
              />
            )}
          </Popup>
        </div>
      </div>

      {/* Row 2: Blue background with total communities */}
      <div className="total-communities-row">
        <div className="indicator" />
        <div className="total-communities-content">
          <span className="communities-count">{communities?.communitiesCount || 0}</span>
          <span className="communities-text">CREATED IN THE APP</span>
        </div>
        <img 
          src={infoIcon} 
          alt="Info" 
          className="info-icon" 
          onClick={() => handleCommunitiesListClick()}
          style={{ cursor: "pointer" }}
        />
      </div>

      <div
        className="statistics-sessions-content"
        style={{ overflow: "unset" }}
      >
        <div className="statistics-sessions-section col" style={{marginBottom:"20px"}}>
          <h4>LOCATION</h4>
          <div className="selector-container" style={{marginBottom: "20px"}}>
            <div
              className={`select ${selected === "country" && "selected"}`}
              onClick={() => setSelected("country")}
            >
              BY COUNTRY
            </div>
            <div
              className={`select ${selected === "city" && "selected"}`}
              onClick={() => setSelected("city")}
            >
              BY CITY
            </div>
          </div>
          {communities.loading ? (
            <Statistics.LoaderInline />
          ) : (
            <>
              {selected === "country" ? (
                <Statistics.Horizontal
                  data={communities?.byCountry?.map((prop) => {  // Changed from communitiesByCountry
                    return {
                      value: prop.country,
                      label: prop.count,
                      info: true, // Enable info icon
                    };
                  })}
                  handleInfo={({ value, label }) => {
                    // Navigate to communities filtered by country
                    history.push(`/dashboard/communities/list?country=${encodeURIComponent(value)}`);
                  }}
                />
              ) : (
                <Statistics.Horizontal
                  data={communities?.byCity?.map((prop) => {    // Changed from communitiesByCity
                    return {
                      value: prop.city,
                      label: prop.count,
                      info: true, // Enable info icon
                    };
                  })}
                  handleInfo={({ value, label }) => {
                    // Navigate to communities filtered by city
                    history.push(`/dashboard/communities/list?city=${encodeURIComponent(value)}`);
                  }}
                />
              )}
            </>
          )}
        </div>
        {communitiesShortcuts.map((pair, i) => {
          return (
            <div className="statistics-sessions-section col" key={i} style={{marginBottom:"20px"}}>
              <h4>{pair.label}</h4>
              {communities.loading ? (
                <Statistics.LoaderInline />
              ) : (
                <Statistics.Horizontal
                  data={communities?.[pair.key]?.map((prop) => {
                    return {
                      value: prop.range,
                      label: prop.count,
                    };
                  })}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  communities: state.dashboard.communities,
  communitiesList: state.dashboard.communitiesList,
});
const mapDispatchToProps = (dispatch) => ({
  getCommunitiesStats: (payload) => dispatch(getCommunitiesStats(payload)),
  getStatisticsSuccess: (payload) => dispatch(getStatisticsSuccess(payload)),
  getCommunitiesList: (payload) => dispatch(getCommunitiesList(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Communities);